import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-md-12 text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-4 mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Parceiro")
  ])
], -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "col-md-9" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = {
  key: 0,
  class: "desconto mb-0 fw-bold"
}
const _hoisted_15 = {
  key: 1,
  class: "card-text desconto mb-0 fw-bold"
}
const _hoisted_16 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_17 = { class: "mt-2 fw-bold" }
const _hoisted_18 = { class: "mt-3 endereco" }
const _hoisted_19 = { class: "endereco" }
const _hoisted_20 = { class: "endereco" }
const _hoisted_21 = { class: "endereco" }
const _hoisted_22 = { class: "col-md-12 mt-3 mb-5" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow" }, null, -1)

import { reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";

//services
import * as clienteService from "@/services/clienteService";
import {f2dec, fdata} from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import imgSemImagem from "@/assets/images/sem-imagem.gif";


export default /*#__PURE__*/_defineComponent({
  __name: 'Parceiro',
  setup(__props) {

//vue
const controle = reactive({
  parceiro: null as clienteService.Parceiro | null,
  status: "" as string,
  erro: "" as string
});

const route = useRoute();

onMounted(() => {
    console.log("Mounted Parceiro.vue");
    if (route.params.parceiroId) {
        const parceiroId = Number(route.params.parceiroId);
        controle.status = "Buscando parceiro...";
        console.log("parceiroId:", parceiroId);
        clienteService.obterParceiros({ parceiroId: parceiroId } as clienteService.ClienteParceirosFiltros)
            .then((r) => {
                controle.status = "";
                controle.parceiro = r.dados[0];
            })
            .catch((error) => {
                console.error("Erro ao buscar parceiro:", error);
                controle.status = "";
                controle.erro = error.message || "Erro desconhecido";
            });
    } else {
        controle.erro = "ID do parceiro não fornecido na URL.";
    }
});


function sair() {
    // Lógica para sair da área do cliente
    controle.status = "Saindo...";
    console.log("Saindo da área do cliente...");
    localStorage.removeItem("clienteToken");
    window.location.reload();
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(imgLogin),
          alt: "Logo",
          class: "img-fluid img-logo mb-3"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (controle.erro == '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(controle.status), 1))
          : _createCommentVNode("", true),
        (controle.erro != '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(controle.erro), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("h3", null, _toDisplayString(controle.parceiro?.nome), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("img", {
          src: controle.parceiro?.arquivo,
          class: "img-fluid"
        }, null, 8, _hoisted_12)
      ]),
      _createElementVNode("div", _hoisted_13, [
        (controle.parceiro?.valorDescontoIni != null && controle.parceiro.valorDescontoIni > 0)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_14, " Desconto: de " + _toDisplayString(controle.parceiro.valorDescontoIni) + " % até " + _toDisplayString(_unref(f2dec)(controle.parceiro.valorDesconto)) + " % ", 1))
          : _createCommentVNode("", true),
        (controle.parceiro?.valorDescontoIni == null || controle.parceiro.valorDescontoIni == 0)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_15, " Desconto: " + _toDisplayString(_unref(f2dec)(controle.parceiro?.valorDesconto)) + " % ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, _toDisplayString(controle.parceiro?.texto), 1),
        (controle.parceiro?.responsavel != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Responsável: " + _toDisplayString(controle.parceiro?.responsavel), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, " Telefone: " + _toDisplayString(controle.parceiro?.telefone), 1),
        _createElementVNode("div", _hoisted_18, _toDisplayString(controle.parceiro?.cidade?.nome) + " - " + _toDisplayString(controle.parceiro?.cidade?.estado), 1),
        _createElementVNode("div", _hoisted_19, _toDisplayString(controle.parceiro?.logradouro) + " " + _toDisplayString(controle.parceiro?.numero), 1),
        _createElementVNode("div", _hoisted_20, _toDisplayString(controle.parceiro?.bairro), 1),
        _createElementVNode("div", _hoisted_21, " CEP: " + _toDisplayString(controle.parceiro?.cep), 1),
        _createElementVNode("div", null, " CNPJ/CPF: " + _toDisplayString(controle.parceiro?.cnpj), 1)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_RouterLink, {
          class: "btn btn-secondary btn-sm mb-5",
          to: "/cliente"
        }, {
          default: _withCtx(() => [
            _hoisted_23,
            _createTextVNode(" Voltar ")
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})